import { FlatRoomTypeEnum } from "../models/enum/flat-room-type.enum";
import { HoldingTypeEnum } from "../models/enum/holding-type.enum";
import { LoanTypeEnum } from "../models/enum/loan-type.enum";
import { MaritalStatusEnum } from "../models/enum/marital-status.enum";
import { OwnershipReasonEnum } from "../models/enum/ownership-reason.enum";
import { ReasonEnum } from "../models/enum/reason.enum";
import { SexEnum } from "../models/enum/sex.enum";
import { StagesStatusEnum } from "../models/enum/stages-status.enum";
import data from "./shared/options.json";
export const ChangeOwnershipReasonCode = [
  {
    "code": "COR1",
    "change_ownership_reason_value": OwnershipReasonEnum.divorce,
    "reason_value": ReasonEnum.marital_status_reason_value,
    "label": "Change in Marital Status",
    "hdb_code": "DV",
    "hdb_description": "Divorce"
  },
  {
    "code": "COR2",
    "change_ownership_reason_value": OwnershipReasonEnum.inclusion_due_to_marriage,
    "reason_value": ReasonEnum.marital_status_reason_value,
    "label": "Inclusion Due to marriage",
    "hdb_code": "MA",
    "hdb_description": "Marriage"
  },
  {
    "code": "COR3",
    "change_ownership_reason_value": OwnershipReasonEnum.financial_difficulties,
    "reason_value": ReasonEnum.financial_circumstances_reason_value,
    "label": "Financial Difficulties",
    "hdb_code": "FH",
    "hdb_description": "Financial Hardship"
  },
  {
    "code": "COR4",
    "change_ownership_reason_value": OwnershipReasonEnum.demise_of_current_owner,
    "reason_value": ReasonEnum.demise_current_owner_reason_value,
    "label": "Demise of Current Owner",
    "hdb_code": "DE",
    "hdb_description": "Death"
  },
  {
    "code": "COR5",
    "change_ownership_reason_value": OwnershipReasonEnum.renunciation,
    "reason_value": ReasonEnum.loss_of_citizenship_reason_value,
    "label": "Current Owner Renounced their SC / PR",
    "hdb_code": "LS",
    "hdb_description": "Loss of Citizenship/ PR Status"
  },
  {
    "code": "COR6",
    "change_ownership_reason_value": OwnershipReasonEnum.moving_out_due_to_marriage,
    "reason_value": ReasonEnum.owner_moving_out_reason_value,
    "label": "Current Owner is Moving Out",
    "hdb_code": "MO",
    "hdb_description": "Moving Out due to Marriage"
  },
  {
    "code": "COR7",
    "change_ownership_reason_value": OwnershipReasonEnum.moving_out_others,
    "reason_value": ReasonEnum.owner_moving_out_reason_value,
    "label": "Moving Out due to Others Reasons",
    "hdb_code": "SE",
    "hdb_description": "Owner Moving Out"
  },
  {
    "code": "COR8",
    "change_ownership_reason_value": OwnershipReasonEnum.medical,
    "reason_value": ReasonEnum.health_reasons_reason_value,
    "label": "Medical Reasons",
    "hdb_code": "MR",
    "hdb_description": "Medical Reason"
  },
]

export const RelationshipWithOwner = data.relationships;

export const ResidentialStatus = [
  {
    code: "A",
    description: "Alien",
  },
  {
    code: "C",
    description: "Singapore Citizen",
  },
  {
    code: "P",
    description: "Singapore Permanent Resident",
  },
  {
    code: "U",
    description: "Unknown",
  },
  {
    code: "N",
    description: "NOT APPLICABLE",
  },
];

export const MaritalStatusCode = [
  {
    code: MaritalStatusEnum.single,
    description: "Single",
  },
  {
    code: MaritalStatusEnum.married,
    description: "Married",
  },
  {
    code: MaritalStatusEnum.windowed,
    description: "Widowed",
  },
  {
    code: MaritalStatusEnum.divorced,
    description: "Divorced",
  }
];

export const LoanTypeCode = [
  {
    code: LoanTypeEnum.no_loan,
    description: "No Loan",
  },
  {
    code: LoanTypeEnum.hdb_loan,
    description: "HDB Loan",
  },
  {
    code: LoanTypeEnum.bank_loan,
    description: "Bank Loan",
  },
  {
    code: LoanTypeEnum.temporary_loan,
    description: "Temporary Loan",
  },
]


export const ApplicationStatusStagesCode = [
  {
    code: StagesStatusEnum.draft,
    description: "Draft",
  },
  {
    code: StagesStatusEnum.pending_consent,
    description: "Pending Consent from applicant",
  },
  {
    code: StagesStatusEnum.pending_payment,
    description: "Pending Payment from applicant",
  },
  {
    code: StagesStatusEnum.pending_documents,
    description: "Pending Documentations from applicant",
  },
  {
    code: StagesStatusEnum.pending_reply,
    description: "Pending reply from applicant",
  },
  {
    code: StagesStatusEnum.make_appointment,
    description: "Applicant to book for appointment",
  },
  {
    code: StagesStatusEnum.pending_solicitor,
    description: "Pending lawyer informations from applicant",
  },
  {
    code: StagesStatusEnum.pending_financial_review,
    description: "Pending review of financial plan from applicant",
  },
  {
    code: StagesStatusEnum.pending_additional_payment,
    description: "Pending additional payment from applicant",
  },
  {
    code: StagesStatusEnum.prepare_completion,
    description: "Preparing for completion",
  },
  {
    code: StagesStatusEnum.application_cancelled,
    description: "Application has been cancelled",
  },
  {
    code: StagesStatusEnum.application_rejected,
    description: "Application has been rejected",
  },
  {
    code: StagesStatusEnum.ipa_granted,
    description: "In-Principle Approval has been granted",
  },
]


export const FlatRoomTypeCode = [
  {
    "code": FlatRoomTypeEnum.room1,
    "description": "1 Rooms",
  },
  {
    "code": FlatRoomTypeEnum.room2,
    "description": "2 Rooms",
  },
  {
    "code": FlatRoomTypeEnum.room3,
    "description": "3 Rooms",
  },
  {
    "code": FlatRoomTypeEnum.room4,
    "description": "4 Rooms",
  },
  {
    "code": FlatRoomTypeEnum.room5,
    "description": "5 Rooms",
  },
  {
    "code": FlatRoomTypeEnum.executive,
    "description": "Executive",
  },
  {
    "code": FlatRoomTypeEnum.hudc,
    "description": "HUDC",
  },
  {
    "code": FlatRoomTypeEnum.multi_generation,
    "description": "Multi-Generation",
  },
]

export const HoldingTypeTypeCode = [
  {
    "code": HoldingTypeEnum.joint_tenancy,
    "description": "Joint Tenancy",
  },
  {
    "code": HoldingTypeEnum.sole_ownership,
    "description": "Sole Ownership",
  },
  {
    "code": HoldingTypeEnum.tenancy_in_common,
    "description": "Tenancy In Common",
  }
]

export const SexCode = [
  {
    "code": SexEnum.male,
    "description": "Male",
  },
  {
    "code": SexEnum.female,
    "description": "Female",
  },
  {
    "code": SexEnum.unknown,
    "description": "Unknown",
  }
]


export const RaceCode = data.races;


export const NationalityCode = data.nationalities;
